module.exports = __webpack_public_path__ + "static/media/Cacao.a6a7ac01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Cacao.jpg
// module id = 316
// module chunks = 0